import { render, staticRenderFns } from "./MarketingCenterCanvas.vue?vue&type=template&id=70410228&scoped=true&"
import script from "./MarketingCenterCanvas.vue?vue&type=script&lang=ts&"
export * from "./MarketingCenterCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingCenterCanvas.vue?vue&type=style&index=0&id=70410228&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70410228",
  null
  
)

export default component.exports